/**
 * Execution block: sets isEnabled on a SceneObject.
 * Has flow in/out + a boolean data input.
 */

import { FlowGraphExecutionBlockWithOutSignal } from "@babylonjs/core/FlowGraph/flowGraphExecutionBlockWithOutSignal";
import type { FlowGraphContext } from "@babylonjs/core/FlowGraph/flowGraphContext";
import type { FlowGraphSignalConnection } from "@babylonjs/core/FlowGraph/flowGraphSignalConnection";
import type { IFlowGraphBlockConfiguration } from "@babylonjs/core/FlowGraph/flowGraphBlock";
import { RichTypeBoolean } from "@babylonjs/core/FlowGraph/flowGraphRichTypes";
import { resolveTarget } from './traceContext';

export class TraceSetActiveBlock extends FlowGraphExecutionBlockWithOutSignal {
    private _targetPath: string;

    constructor(config?: IFlowGraphBlockConfiguration & { target?: string }) {
        super(config);
        this._targetPath = config?.target ?? '';
        this.registerDataInput("state", RichTypeBoolean);
    }

    public override _execute(context: FlowGraphContext, _callingSignal: FlowGraphSignalConnection): void {
        const target = resolveTarget(context, this._targetPath);
        if (target) {
            const newState = this.getDataInput("state")!.getValue(context) as boolean;
            target.setActive(newState);
        }
        this.out._activateSignal(context);
    }

    public override getClassName(): string {
        return "TraceSetActiveBlock";
    }
}
